import STAT_LIST from '../constants/statList';
import EXPERIENCE_TABLE from '../constants/experienceTable';

export const isHighestLevel = users => (user, stat) => {
  const filteredStats = users.filter(u => u.id !== user.id && !u.isPlaceholder && !u.invalid).map(u => u.stats.filter(s => s.key === stat.key)[0]);
  return filteredStats.reduce((highestExp, currentStat) => {
    return currentStat.details.exp > highestExp ? currentStat.details.exp : highestExp;
  }, 0) <= stat.details.exp;
};

export const parseStats = (user, stats) => {
  if (!stats.length) {
    return {
      ...user,
      overall: {},
      stats: [],
      invalid: true
    };
  }

  const parsedStats = stats.split('\n').splice(0, STAT_LIST.length);
  const results = [];

  const fixZeroOverall = skills => {
    let exp = 0;
    let level = 0;

    skills.forEach(skill => {
      exp += skill.details.exp;
      level += skill.details.level;
    });

    return {
      level,
      exp,
      rank: '',
    };
  };

  parsedStats.forEach((stat, i) => {
    const [rank, level, exp] = stat.split(',');

    const getActualLevel = (level, exp) => {
      if (level < 99) {
        return level;
      }

      let actualLevel;

      for (const item of EXPERIENCE_TABLE) {
        if (item.exp <= exp) {
          actualLevel = item.level;
        } else {
          break;
        }
      }

      return actualLevel;
    };

    const result = {
      name: STAT_LIST[i].display,
      key: STAT_LIST[i].key,
      details: {
        rank: rank ? parseInt(rank.replace('-1', '0'), 10) : '',
        level: level ? parseInt(level.replace('-1', '0'), 10) : '',
        exp: exp ? parseInt(exp.replace('-1', '0'), 10) : ''
      }
    };

    if (i > 0) {
      result.details.level = getActualLevel(result.details.level, result.details.exp);
    }

    results.push(result);
  });

  const overall = results.shift();
  overall.details = (overall.details.level === 0 && overall.details.exp === 0) ? fixZeroOverall(results) : overall.details;

  return {
    ...user,
    overall,
    stats: results
  };
};



// WEBPACK FOOTER //
// ./src/factories/StatFactory.js